module.exports = __webpack_public_path__ + "static/media/about-adsticker-ko@2x.20de54fd.png";